
import {defineComponent} from "vue";
export default defineComponent({
  name: "icon-add-new"
});
